export const quickEmojiReactions = [':heavy_plus_sign:', ':hearts:', ':+1:', ':white_check_mark:'] as const
